var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.977 13.48c-.209 4.62-3.477 10.936-9.782 18.95C31.67 40.813 26.141 45 21.621 45c-2.794 0-5.161-2.548-7.095-7.66-1.295-4.69-2.582-9.381-3.875-14.058-1.44-5.115-2.98-7.671-4.628-7.671-.359 0-1.609.746-3.765 2.24L0 14.971A644.192 644.192 0 0 0 6.996 8.8c3.15-2.7 5.518-4.115 7.098-4.263 3.726-.358 6.023 2.165 6.89 7.56.922 5.824 1.572 9.445 1.93 10.864 1.078 4.827 2.258 7.235 3.55 7.235 1.002 0 2.51-1.558 4.519-4.68 2.01-3.125 3.079-5.5 3.226-7.137.288-2.698-.788-4.04-3.226-4.04-1.149 0-2.334.241-3.55.744 2.37-7.596 6.886-11.29 13.558-11.074 4.942.137 7.276 3.3 6.985 9.47",
    fill: "#909495"
  })));
};
export default SvgVimeo;